document.addEventListener("scroll", function () {
    var pageTop = window.pageYOffset;
    var pageBottom = pageTop + window.innerHeight;
    var tags = document.querySelectorAll(".animate-logo.fadein");

    tags.forEach(function (tag) {
        if (tag.getBoundingClientRect().top + window.pageYOffset < pageBottom) {
        tag.classList.add("visible");
        } else {
        tag.classList.remove("visible");
        }
    });
});